"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const plugins_1 = require("../plugins");
const Cesium = window.Cesium;
/* LOG
    * new (10/09/2021)
*/
class EnvironmentController extends plugins_1.FdmPlugin {
    constructor() {
        super(...arguments);
        this.controls = {
            showStars: { value: true, type: 'check' },
            // noSkyColor: { value: Cesium.Color.BLACK.withAlpha(0.6), type:'color' },
            showSun: { value: true, type: 'check' },
            showMoon: { value: true, type: 'check' },
            showAtmosphere: { value: true, type: 'check' },
            showAtmosphereHaze: { value: true, type: 'check' },
        };
    }
    itemInjected() {
        const viewer = this.services.mapService.viewer;
        /* console.log('## environment', {
            skyBox: viewer.scene.skyBox,
            sun: viewer.scene.sun,
            moon: viewer.scene.moon,
            skyAtmosphere: viewer.scene.skyAtmosphere,
            globe: viewer.scene.globe.show,
            globeShadows: viewer.scene.globe.shadows,
        }); */
    }
    refresh(newvalue = null, section = null) {
        // check in with mama
        super.refresh(newvalue, section);
        const viewer = this.services.mapService.viewer;
        viewer.scene.skyBox.show = this.controls.showStars.value;
        viewer.scene.sun.show = this.controls.showSun.value;
        viewer.scene.moon.show = this.controls.showMoon.value;
        viewer.scene.skyAtmosphere.show = this.controls.showAtmosphere.value;
        viewer.scene.fog.enabled = this.controls.showAtmosphereHaze.value;
        // console.log('## env colors globe,scene', viewer.scene.globe.baseColor, viewer.scene.backgroundColor )
    }
    end() {
    }
}
EnvironmentController.meta = {
    label: 'PLUGINS.ENVIRONMENT_CONTROLLER.LABEL',
    name: 'environment-controller',
    translator: 'PLUGINS.ENVIRONMENT_CONTROLLER',
    tooltip: 'PLUGINS.ENVIRONMENT_CONTROLLER.TOOLTIP',
    shortcut: true,
    icon: 'sliders-v',
    // hideHeader: true,
    // offsetX: 'context',
    // offsetY: 'context',
    category: plugins_1.FdmPlugin.category.generic,
    types: [plugins_1.FdmPlugin.types.cameraController],
    cardinality: plugins_1.FdmPlugin.cardinality.one,
};
exports.EnvironmentController = EnvironmentController;
